import { months } from 'constants/date';
import moment from 'moment';

import {
    SET_ILLNESS_DATA,
    SET_ILLNESS_DATA_LOADING,
    SET_ILLNESS_FILTER_OPTIONS,
    SET_ILLNESS_FILTERS,
    RESET_ILLNESS_FILTERS,
    SET_ILLNESS_PROPERTY_ID
} from '@/redux/mutations';

export const initialState = {
    property_id: null,
    data: {},
    loading: true,
    optionsFilters: {
        years: [moment().year()],
        months: months,
        illness: ['Todas'],
        category: ['Todos'],
        sex: ['Todos'],
        isPurchased: ['Todos']
    },
    selectedFilters: {
        years: [moment().year()],
        months: months,
        illness: ['Todas'],
        category: ['Todos'],
        sex: 'Todos',
        isPurchased: 'Todos'
    }
};

const indicatorsPanelIllnessReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case SET_ILLNESS_PROPERTY_ID:
            return {
                ...state,
                property_id: actions.payload
            };
        case SET_ILLNESS_DATA:
            return {
                ...state,
                data: actions.payload
            };
        case SET_ILLNESS_DATA_LOADING:
            return {
                ...state,
                loading: actions.payload
            };
        case SET_ILLNESS_FILTER_OPTIONS:
            return {
                ...state,
                optionsFilters: actions.payload
            };
        case SET_ILLNESS_FILTERS:
            return {
                ...state,
                selectedFilters: actions.payload
            };
        case RESET_ILLNESS_FILTERS:
            return {
                ...state,
                selectedFilters: {
                    illness: ['Todas'],
                    category: ['Todos'],
                    sex: 'Todos',
                    isPurchased: 'Todos'
                }
            };
        default:
            return state;
    }
};

export default indicatorsPanelIllnessReducer;
